import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="List">{props.title || 'List'}</title>
      <g>
        <path d="M2.1 0h114.3v114.3h-114.3zM200.1 0h311.9v114.3h-311.9zM2.1 197.8h114.3v114.3h-114.3zM200.1 197.8h311.9v114.3h-311.9zM2.1 396.7h114.3v114.3h-114.3zM200.1 396.7h311.9v114.3h-311.9z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/list.js